export default function _has(prop,obj){return Object.prototype.hasOwnProperty.call(obj,prop);}